var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"content"},[_c('h1',{staticClass:"title",on:{"click":_vm.goback}},[_c('span',{staticClass:"icon-back"}),_vm._v(_vm._s(_vm.title)+" ")]),_vm._t("default")],2),_c('div',{staticClass:"contact"},[_c('author-contact-us')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }